import * as React from "react";

const BadgeOnBackorder: React.FC = () => {
    return (
        <svg
            width="16px"
            height="17px"
            viewBox="0 0 16 17"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M7.99999964,16.5001 C10.8581247,16.5001 13.4991407,14.9753083 14.9282036,12.5001 C16.3572655,10.0248917 16.3572655,6.97530876 14.9282036,4.5001 C13.4991407,2.02489172 10.8581247,0.5001 7.99999964,0.5001 C5.14187527,0.5001 2.50085878,2.02489172 1.07179642,4.5001 C-0.357265949,6.97530876 -0.357265949,10.0248917 1.07179642,12.5001 C2.50085878,14.9753083 5.14187527,16.5001 7.99999964,16.5001 Z M11.0593748,6.5001 L10.5281248,7.03135 L9.05937481,8.5001 L10.5281248,9.96885 L11.0593748,10.5001 L10,11.5594748 L9.46875,11.0282248 L8,9.55947481 L6.53125,11.0282248 L6,11.5594748 L4.94062519,10.5001 L5.47187519,9.96885 L6.94062519,8.5001 L5.47187519,7.03135 L4.94062519,6.5001 L6,5.44072519 L6.53125,5.97197519 L8,7.44072519 L9.46875,5.97197519 L10,5.44072519 L11.0593748,6.5001 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(BadgeOnBackorder);
